var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.show404Message)?_c('ProductResourceHelperComponents1MainPage',{attrs:{"productResourceId":_vm.productResourceId}}):_c('div',[_c('App4PageNotFound')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }